export default class ManageAccessViewmodel {
    public id: number | null = null;
    public accessToId: number | number[] = 0;
    public userId: string = '';
    public accessLevel: number = 0;
    public accessType: number = 0;
    public days: number | null = null;
    public projectId: number = 0;
}